import './App.css';
import { useEffect } from 'react';
import CurveSolverMainScene from './CurveSolver/CurveSolverMainScene';
import { ThemeProvider } from '@mui/material';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import Login from './Auth/Login';
import ProtectedRoute from './Shared/ProtectedRoute';
import CreateValidatorTheme from './Shared/Design/CreateValidatorTheme';
import ProjectsScene from './Projects/ProjectsScene';
import TiltValidationScene from './TiltValidator/TiltValidationScene';
// import { LicenseInfo } from '@mui/x-data-grid';
import ValidatorsMainScene from './Validators/ValidatorsMainscene';
import CurveSolverExternalImporter from './CurveSolver/CurveSolverExternalImporter';
import SlopePlugin from './TiltValidator/SlopePlugin';
import ProjectDetailScene from './Projects/ProjectDetailScene';
import AdminScene from './Users/AdminScene';
import UserScene from './Users/UserScene';
import BimValidatorFrame from './Validators/BimValidatorFrame';
import UpdaterScene from './Updater/UpdaterScene';
import CurveSolverHelpScene from './CurveSolver/CurveSolverHelpScene';
import UserSignupScene from './Users/UserSignupScene';
import UserResetPasswordScene from './Users/UserResetPasswordScene';
import EtcsDataMainScene from './ETCS/EtcsDataMainScene';
import RedirectHandler from './Auth/RedirectHandler';
import ToolLogin from './Auth/ToolLogin';
import PWLoginScene from './ProjectWise/PWLoginScene';
import PWMainScene from './ProjectWise/PWMainScene';
import { PwUserProvider } from './ProjectWise/Context/PWUserDataProvider';
import LoginToolGateRedirect from './Routes/LoginToolGateRedirect';
import ProtectedToolRoute from './Shared/Protected/ProtectedToolRoute';
import { useValidatorStore } from './CurveSolver/Stores/ValidatorStore';
import { ValidatorsEnum } from './CurveSolver/Enums/ValidatorsEnum';

function getValidatorTitle(validator?: ValidatorsEnum) {
  if (validator === ValidatorsEnum.CurveSolver) {
    return 'GPK Validátor';
  }

  if (validator === ValidatorsEnum.SlopeGuard) {
    return 'SlopeGuard';
  }

  if (validator === ValidatorsEnum.BimValidator) {
    return 'IFC Validátor';
  }

  return 'Validátory';
}

function buildPageTitle(pathname: string, validator?: ValidatorsEnum) {
  const pageTitle = (label: string) => `${label}`;

  if (pathname === '/' || pathname.startsWith('/login') || pathname.startsWith('/tool-login')) {
    return pageTitle('Přihlášení');
  }

  if (pathname.startsWith('/gateredirect') || pathname.startsWith('/auth-callback')) {
    return pageTitle('Přesměrování');
  }

  if (pathname.startsWith('/updates')) {
    return pageTitle('Aktualizace');
  }

  if (pathname.startsWith('/pwlogin')) {
    return pageTitle('ProjectWise Přihlášení');
  }

  if (pathname.startsWith('/pwmain')) {
    return pageTitle('ProjectWise');
  }

  if (pathname.startsWith('/etcs')) {
    return pageTitle('ETCS');
  }

  if (pathname.startsWith('/help')) {
    return pageTitle('Nápověda');
  }

  if (pathname.startsWith('/curveimport')) {
    return pageTitle('GPK Validátor | Import');
  }

  if (pathname.startsWith('/solvermain')) {
    return pageTitle('GPK Validátor | Trasa');
  }

  if (pathname.startsWith('/projects-slope')) {
    return pageTitle('SlopeGuard | Projekty');
  }

  if (pathname.startsWith('/projects-curve')) {
    return pageTitle('GPK Validátor | Projekty');
  }

  if (pathname.startsWith('/slopeguard') || pathname.startsWith('/slopevalidation') || pathname.startsWith('/slopeplugin')) {
    return pageTitle('SlopeGuard');
  }

  if (pathname.startsWith('/projects')) {
    return pageTitle(`${getValidatorTitle(validator)} | Projekty`);
  }

  if (pathname.startsWith('/routes/')) {
    return pageTitle(`${getValidatorTitle(validator)} | Projekt`);
  }

  return pageTitle(getValidatorTitle(validator));
}

function PageTitleSync() {
  const location = useLocation();
  const { validator, initValidator } = useValidatorStore();

  useEffect(() => {
    if (validator === ValidatorsEnum.None) {
      initValidator();
    }
  }, [initValidator, validator]);

  useEffect(() => {
    document.title = buildPageTitle(location.pathname.toLowerCase(), validator);
  }, [location.pathname, validator]);

  return null;
}

function App() {
  // LicenseInfo.setLicenseKey('cea41abee7db7cb80eeb1a77ddaeaef8Tz03MzM5NixFPTE3MjQ1MjM4OTAwMDAsUz1wcmVtaXVtLExNPXN1YnNjcmlwdGlvbixLVj0y');
  /* const curveSolverTheme = createTheme({
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            fontWeight: 'bold', // Set the font weight to 'bold' for all buttons
          },
        },
      },
    },
  });
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Login />,
    },
    {
      path: "/tilt",
      element: <TiltValidationScene />,
    },
    {
      path: "/tilt",
      element: <TiltValidationScene />,
    },
    {
      path: "/solverMain",
      element: <ProtectedRoute><CurveSolverMainScene /></ProtectedRoute>,
    },
  ]); */
  const theme = CreateValidatorTheme();
  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        {/* <RouterProvider router={router} /> */}
        <BrowserRouter>
          <PageTitleSync />
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="gateredirect/:redirect/:lang/:session" element={<LoginToolGateRedirect />} />
            <Route path="/updates" element={<UpdaterScene />} />
            <Route path="/pwlogin" element={<PWLoginScene />} />
            <Route path="/pwmain" element={<PwUserProvider><PWMainScene /></PwUserProvider>} />

            <Route path="/login/:redirect" element={<Login />} />
            {/* <Route path="validators" element={<ProtectedRoute><ValidatorsMainScene /></ProtectedRoute>} /> */}
            <Route path="projects" element={<ProtectedToolRoute><ProjectsScene /></ProtectedToolRoute>} />
            <Route path="projects-slope" element={<ProtectedToolRoute><ProjectsScene onlySlope /></ProtectedToolRoute>} />
            <Route path="projects-curve" element={<ProtectedToolRoute><ProjectsScene onlyCurve /></ProtectedToolRoute>} />
            <Route path="routes/:projectId" element={<ProtectedToolRoute><ProjectDetailScene /></ProtectedToolRoute>} />
            <Route path="solverMain/:id?" element={<ProtectedToolRoute><CurveSolverMainScene /></ProtectedToolRoute>} />
            <Route path="slopeguard" element={<ProtectedToolRoute><TiltValidationScene /></ProtectedToolRoute>} />
            <Route path="curveimport" element={<ProtectedToolRoute><CurveSolverExternalImporter /></ProtectedToolRoute>} />
            <Route path="slopeplugin" element={<SlopePlugin  />} />
            <Route path="slopeplugin/logged" element={<SlopePlugin isLogged />} />
            <Route path="slopevalidation/:id" element={<ProtectedToolRoute><TiltValidationScene /></ProtectedToolRoute>} />

            {/*  */}
            <Route path="help" element={<CurveSolverHelpScene />} ></Route>
            {/* <Route path="usersignup" element={<UserSignupScene />} />
             */}
            <Route path="auth-callback/" element={<RedirectHandler />} />
            <Route path="auth-callback/:hash" element={<RedirectHandler />} />
            <Route path="etcs" element={<EtcsDataMainScene />} />
            <Route path="tool-login" element={<ToolLogin />} />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </div>
  );
}

export default App;
